import { useContext } from "react";

import { PageHeaderContext } from "../PageHeaderProvider";

export const usePageHeaderContext = () => useContext(PageHeaderContext);
